"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountType = void 0;
// Superset of account type from Quickbooks and NetSuite
// Note: these are case-sensitive!
// QBO docs: https://developer.intuit.com/app/developer/qbo/docs/api/accounting/most-commonly-used/account
// NetSuite docs: https://docs.oracle.com/en/cloud/saas/netsuite/ns-online-help/section_3947502870.html
var AccountType;
(function (AccountType) {
    AccountType["ACCOUNTS_PAYABLE"] = "Accounts Payable";
    AccountType["ACCOUNTS_RECEIVABLE"] = "Accounts Receivable";
    AccountType["BANK"] = "Bank";
    AccountType["COST_OF_GOODS_SOLD"] = "Cost of Goods Sold";
    AccountType["CREDIT_CARD"] = "Credit Card";
    AccountType["EQUITY"] = "Equity";
    AccountType["EXPENSE"] = "Expense";
    AccountType["FIXED_ASSET"] = "Fixed Asset";
    AccountType["INCOME"] = "Income";
    AccountType["LONG_TERM_LIABILITY"] = "Long Term Liability";
    AccountType["OTHER_ASSET"] = "Other Asset";
    AccountType["OTHER_CURRENT_ASSET"] = "Other Current Asset";
    AccountType["OTHER_CURRENT_LIABILITY"] = "Other Current Liability";
    AccountType["OTHER_EXPENSE"] = "Other Expense";
    AccountType["OTHER_INCOME"] = "Other Income";
    AccountType["DEFERRED_REVENUE"] = "Deferred Revenue";
    AccountType["DEFERRED_EXPENSE"] = "Deferred Expense";
    AccountType["UNBILLED_RECEIVABLE"] = "Unbilled Receivable";
    AccountType["NON_POSTING"] = "Non Posting";
})(AccountType || (exports.AccountType = AccountType = {}));
